// extracted by mini-css-extract-plugin
export default {"container":"Header_container__zmwVK","flex":"Header_flex__8wvhd","header":"Header_header__Lhnr8","btn_contato":"Header_btn_contato__1kS3d"};